import React, { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0
}: AnimatedSectionProps) {
  const shouldReduceMotion = useReducedMotion();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.08
  });
  return <motion.div ref={ref} initial={shouldReduceMotion ? false : {
    opacity: 0,
    y: 18
  }} animate={inView || shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 18
  }} transition={{
    duration: 0.26,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} className={className} data-id="element-20" data-mp="2xwthuror1s4d">
      {children}
    </motion.div>;
}